import React from 'react';
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';
import ReportProblemOutlined from '@material-ui/icons/ReportProblemOutlined';
import { MOBILE_NUMBER_REQUIRED_LABEL } from './types';

// Sits directly under the input, where the "Not Verified" chip could not: the chip was
// pinned beside the field label and had no room for the reason or the way out.
export const MobileNumberRequirement = () => (
   <div className="mobile-number-requirement">
      <FiberManualRecord className="mobile-number-requirement-dot" />
      <span className="mobile-number-requirement-label">
         {MOBILE_NUMBER_REQUIRED_LABEL}
      </span>
   </div>
);

interface MobileNumberWarningProps {
   messages: string[];
}

// Shared by the read-only view and the edit form so a duplicate number reads the same on
// either side of Change.
const MobileNumberWarning = ({ messages }: MobileNumberWarningProps) => {
   if (!messages.length) return null;

   return (
      <div className="mobile-number-warning" role="alert">
         <ReportProblemOutlined className="mobile-number-warning-icon" />
         <div className="mobile-number-warning-body">
            {messages.map(message => (
               <span className="mobile-number-warning-message" key={message}>
                  {message}
               </span>
            ))}
         </div>
      </div>
   );
};

export default MobileNumberWarning;
